export { isAnyConcatSpec, isHConcatSpec, isVConcatSpec } from './concat';
export { isFacetSpec } from './facet';
export { isLayerSpec } from './layer';
export { isRepeatSpec } from './repeat';
export { isUnitSpec } from './unit';
//# sourceMappingURL=index.js.map